/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type ScheduleQuarterMode = typeof ScheduleQuarterMode[keyof typeof ScheduleQuarterMode];


export const ScheduleQuarterMode = {
  None: 'None',
  Repeat: 'Repeat',
  Skip: 'Skip',
} as const;
